export default function () {
  return {
    user: {},
    loading: false,
  }
}
